import { Select } from "antd";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getPopupContainer } from "../../../../../helpers/popUp";
import { selectFilterSearch } from "../../../../../helpers/StringHelper";
import { StakeholderService } from "../../../../../services";

const PER_PAGE = 20;

export default function CustomSelect({
  value,
  focusParticipant,
  formValue = {},
  onChange = () => { },
  onClear = () => { },
  label = '',
  placeholder,
  id,
  disabled = false,
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [valToSearch, setValToSearch] = useState('');
  const abort = useRef();
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const onSearch = useMemo(() => debounce(setValToSearch, 400), []);

  const _fetch = useCallback(async (_page, append = true) => {
    try {
      setLoading(true)

      if (abort.current) {
        abort.current.abort();
      }

      const abortC = new AbortController();
      abort.current = abortC;

      const result = await StakeholderService.getOptions({
        filters: valToSearch ? {
          pmeProject: id,
          name: valToSearch,
          category: 'corporation',
          economicSector: 'miningMineralTrade',
          authorId: { $in: formValue?.supplyChainInformationSources || [] },
        } : {
          pmeProject: id,
          category: 'corporation',
          economicSector: 'miningMineralTrade',
          authorId: { $in: formValue?.supplyChainInformationSources || []}
        },
        signal: abortC.signal,
      });

      if (result && result.data) {
        const res = result.data;

        if (Array.isArray(res)) {
          setTotalItems(result.data.totalItems);
          setPage(_page)

          const _res = res.map((v) => ({
            value: v.id,
            label: v.name,
            authorId: v.authorId,
          }));

          let _options = append ? [...options] : [];

          if (value) {
            if (
              _res.find((r) => r.value === value.value) || _options.find((r) => r.value === value.value)
            ) {
              setOptions([..._options, ..._res])
            } else {
              setOptions([value, ..._options, ..._res])
            }
          } else {
            setOptions([..._options, ..._res])
          }
        }
        setLoading(false)
      }
    } catch (err) {
      console.log(err);
      setLoading(false)
    }
  }, [valToSearch, value, options, id]);

  const _options = useMemo(() => options.map((o) => ({
    ...o,
    disabled: !(formValue?.supplyChainInformationSources || []).includes(o.authorId),
  })), [formValue, options]);

  useEffect(() => {
    if (id) {
      _fetch(1, false);
    }
    // }, [valToSearch]);
  }, [id]);

  const onScroll = (e) => {
    const { target } = e;
    if (!loading &&
      (target.scrollTop + target.offsetHeight + 60) >= target.scrollHeight
    ) {
      const loaded = page * PER_PAGE;
      const canFetch = loaded < totalItems;
      if (canFetch) {
        _fetch(page + 1, true);
      }
    }
  }

  const _onChange = (v) => {
    const _v = _options.find((o) => o.value === v);
    if (_v) {
      onChange(_v);
    }
  }

  const _onSearch = (v) => {
    setSearchValue(v);
    onSearch(v);
  };

  useEffect(() => {
    if (Array.isArray(formValue?.supplyChainInformationSources) && value) {
      const _opt = _options.find((o) => o.value === value.value);

      if (_opt && !formValue?.supplyChainInformationSources.includes(_opt.authorId)) {
        onClear();
      }
    }

  }, [formValue]);

  const _val = value ? value.value : undefined;


  return (
    <div className="row-item flex-c">
      <label className="label">{label}</label>
      <Select
        {...getPopupContainer()}
        value={_val}
        onChange={_onChange}
        loading={loading}
        onPopupScroll={onScroll}
        disabled={disabled}
        size="large"
        searchValue={searchValue}
        onSearch={_onSearch}
        showSearch
        className="custom-select white"
        filterOption={selectFilterSearch}
        // filterOption={false}
        allowClear={true}
        onClear={onClear}
        placeholder={placeholder || label}
      >
        {_val && loading && typeof focusParticipant === 'string' ? (
          <Select.Option
            value={_val}
            disabled
          >
            {focusParticipant}
          </Select.Option>
        ) : null}
        {_options.map((opt, i) => (
          <Select.Option
            key={`options-${opt.id}-${i}`}
            value={opt.value}
            disabled={opt.disabled}
          >
            {opt.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}
